import {Column} from 'react-table'
import {VerificationDate} from './VerificationDate'
import {CustomerName} from './CustomerName'
import { PersonKycCustomHeader } from './CustomHeader'
import { VerificationCheck } from './VerificationCheck'
import { IVerification } from '../../../interfaces/IVerification'
import { VerificationStatus } from './VerificationStatus'

const tableColumns: ReadonlyArray<Column<IVerification>> = [
  {
    Header: (props) => (
      <PersonKycCustomHeader tableProps={props} title='Performed On' className='min-w-150px' />
    ),
    id: 'performedon',
    Cell: ({...props}) => <VerificationDate date={props.data[props.row.index].performedon} />,
  },
  {
    Header: (props) => (
      <PersonKycCustomHeader tableProps={props} title='Performed By' className='min-w-200px' />
    ),
    id: 'performedby',
    Cell: ({...props}) => <CustomerName customerName={props.data[props.row.index].performedby} />,
  },
  {
    Header: (props) => (
      <PersonKycCustomHeader tableProps={props} title='Verification Type' className='min-w-150px' />
    ),
    id: '_type',
    Cell: ({...props}) => {
      return <VerificationCheck check={props.data[props.row.index]._type} />
    },
  },
  {
    Header: (props) => (
      <PersonKycCustomHeader tableProps={props} title='Request Status' className='min-w-150px' />
    ),
    id: 'requeststatus',
    Cell: ({...props}) => {
      return <VerificationStatus status={props.data[props.row.index]?.requeststatus} />
    },
  },
]

export {tableColumns}
